import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'context/translation'

function NavItem({ label, path, icon }) {
  const { t } = useTranslation()
  const [active, setActive] = useState(false)
  const [hover, setHover] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    setActive(pathname === path.replace('.', ''))
  }, [path, pathname])

  // On the walaa-orange sidebar, text is white. The active item uses a
  // "floodlight" highlight — a translucent white wash with a soft glow.
  const style = {
    color: '#ffffff',
    fill: '#ffffff',
    backgroundColor: active
      ? 'rgba(255,255,255,0.22)'
      : hover
      ? 'rgba(255,255,255,0.12)'
      : 'transparent',
    boxShadow: active
      ? 'inset 0 0 0 1px rgba(255,255,255,0.28), 0 6px 18px rgba(0,0,0,0.18)'
      : 'none',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  }

  return (
    <li>
      <Link
        to={path}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={style}
        className='flex items-center p-2 rounded-lg group'
      >
        {icon}
        <span className='ms-3'>{t(label)}</span>
      </Link>
    </li>
  )
}

export default NavItem
